import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function PresupuestoCompleto(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  let navigate = useNavigate();

  const exportColumnsIngresos = [
    { title: "Concepto Ingresos", dataKey: "presupuestoingreso" },
    { title: "Diferido Total", dataKey: "diferidoreal" },
    { title: "Diferido Cobrable", dataKey: "diferidoperiodo" },
    { title: "Facturación Real", dataKey: "facturacionreal" },
    { title: "Facturación Cobrable", dataKey: "facturacionperiodo" },
    { title: "Total a Cobrar", dataKey: "total" },
  ];

  const exportColumns = [
    { title: "ID Presupuesto", dataKey: "id_presupuesto" },
    { title: "Concepto", dataKey: "concepto" },
    { title: "Presupuestado", dataKey: "importe" },
    { title: "Gastado", dataKey: "gastado" },
    { title: "Diferencia", dataKey: "diferencia" },
    { title: "%", dataKey: "porcentaje" },
  ];

  const [concepto, guardarConcepto] = useState(null);
  const [visibleFechas, setVisibleFechas] = useState(false);
  const [detalle, guardarDetalle] = useState(null);
  const [fecha, guardarFecha] = useState(null);
  const [periodo1, guardarPeriodo1] = useState(null);
  const [periodo2, guardarPeriodo2] = useState(null);
  const [periodo3, guardarPeriodo3] = useState(null);
  const [periodoActivo, setPeriodoActivo] = useState(true);
  const [periodoSeleccionado, guardarPeriodoSeleccionado] = useState(null);

  const toast = useRef(null);

  let { sector } = useParams();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    statusAcceso2,
    conceptos,
    conceptosPresupuesto,
    conceptosPresupuestoPeriodo,
    listadoExcel,
    periodoPresupuesto,
    presupuestoIngresos,
    obtenerConceptos,
    obtenerConceptosPresupuesto,
    obtenerConceptosPresupuestosPeriodo,
    obtenerAcceso,
    obtenerAcceso2,
    agregarConceptoPresupuesto,
    actualizarConceptoPresupuesto,
    obtenerPeriodoPresupuesto,
    actualizarPeriodoPresupuesto,
    guardarPeriodoPresupuesto,
    eliminarConceptoPresupuesto,
    obtenerPresupuestoIngresosUnificado,
    obtenerOrdenesPagosListado,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "PresupuestoCompleto",
      });
    }
  }, [state]);

  useEffect(() => {
    obtenerPeriodoPresupuesto();
    obtenerConceptos();
  }, []);

  useEffect(() => {
    if (periodoPresupuesto) {
      obtenerPresupuestoIngresosUnificado({
        sector: "todos",
        periodo: periodoPresupuesto.periodo,
      });

      const [mes, anio] = periodoPresupuesto.periodo.split("/").map(Number);
      const anioCompleto = anio < 100 ? 2000 + anio : anio;

      const primerDia = new Date(anioCompleto, mes - 1, 1);
      const ultimoDia = new Date(anioCompleto, mes, 0);

      let fdesde = primerDia;
      primerDia.setHours(0, 0, 0, 0);
      let fhasta = ultimoDia;
      ultimoDia.setHours(23, 59, 59, 999);

      obtenerConceptosPresupuesto({
        fdesde: fdesde,
        fhasta: fhasta,
        filtroFechas: "pago",
      });
    }
  }, [periodoPresupuesto]);

  const datosAplanados = conceptosPresupuesto.map((item) => ({
    "conceptos.id_presupuesto": item.conceptos?.id_presupuesto,
    "conceptos.nombre": item.conceptos?.nombre,
    importe: Number(item.importe).toLocaleString("en-US", {
      minimumFractionDigits: 2,
    }),
  }));

  function calcularPeriodoAnterior(periodo) {
    // 1. Separar el mes y el año del string (ej: "01/26")
    const [mesStr, añoStr] = periodo.split("/");

    // 2. Crear un objeto Date (usamos el día 1 por defecto)
    // Nota: El año se suma a 2000 para obtener el año completo (ej: 2026)
    // El mes en JS es base 0 (0 = enero), por eso restamos 1
    let fecha = new Date(parseInt("20" + añoStr), parseInt(mesStr) - 1, 1);

    // 3. Restar un mes
    fecha.setMonth(fecha.getMonth() - 1);

    // 4. Formatear de vuelta a MM/YY
    let mesAnterior = (fecha.getMonth() + 1).toString().padStart(2, "0");
    let añoAnterior = fecha.getFullYear().toString().slice(-2);

    return `${mesAnterior}/${añoAnterior}`;
  }

  const calendar = (e) => {
    setVisibleFechas(true);
  };
  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = () => {
    //e.preventDefault();
    //Validar

    if (!periodoSeleccionado || periodoSeleccionado === null) {
      mensajeAlerta("Presupuesto", "Debe seleccionar período !.", "error");
      return;
    }

    guardarPeriodoPresupuesto({
      ...periodoPresupuesto,
      periodo: periodoSeleccionado,
    });

    let elem = document.getElementById("refrescarPeriodo");
    if (elem) {
      setTimeout(() => {
        elem.click();
      }, 1000);
    }
  };

  const refrescarPeriodoActivo = async () => {
    obtenerPresupuestoIngresosUnificado({
      sector: "todos",
      periodo: periodoPresupuesto.periodo,
    });

    obtenerConceptosPresupuesto({
      periodo: periodoPresupuesto.periodo,
    });
    onHideFechas();
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Conceptos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  const downloadClick = async () => {
    const [mes, anio] = periodoPresupuesto.periodo.split("/").map(Number);
    const anioCompleto = anio < 100 ? 2000 + anio : anio;

    const primerDia = new Date(anioCompleto, mes - 1, 1);
    const ultimoDia = new Date(anioCompleto, mes, 0);

    let fdesde = primerDia;
    primerDia.setHours(0, 0, 0, 0);
    let fhasta = ultimoDia;
    ultimoDia.setHours(23, 59, 59, 999);

    await obtenerOrdenesPagosListado({
      fdesde: fdesde,
      fhasta: fhasta,
      filtroFechas: "pago",
    }).then((data) => {
      let elem = document.getElementById("expButtonExcel");
      if (elem) {
        elem.click();
      }
    });
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("landscape", "mm", "legal");
        doc.setFontSize(10);
        doc.text(
          `Presupuesto del período ${periodoPresupuesto.periodo}`,
          30,
          8,
        );

        doc.setFontSize(6);
        const pageWidth = doc.internal.pageSize.getWidth();
        const halfWidth = pageWidth / 1.2;
        doc.setLineHeightFactor(0.5); // Doble espacio

        doc.autoTable(exportColumnsIngresos, presupuestoIngresos, {
          tableWidth: halfWidth, // La tabla solo ocupará el 50%
          columnStyles: {
            1: {
              halign: "right",
            },
            2: {
              halign: "right",
            },
            3: {
              halign: "right",
            },
            4: {
              halign: "right",
            },
            5: {
              halign: "right",
            },
          },
          didParseCell: (data) => {
            if (data.cell && data.cell.section === "head") {
              switch (data.cell.raw) {
                case "Diferido Total":
                case "Diferido Cobrable":
                case "Facturación Real":
                case "Facturación Cobrable":
                case "Total a Cobrar":
                  data.cell.styles.halign = "right";
                  break;
                default:
                  data.cell.styles.halign = "left";
                  break;
              }
            }
            if (data.section === "body" && data.row.index === 5) {
              data.cell.styles.fontStyle = "bold";
            }
            if (data.section === "body" && data.row.index === 14) {
              data.cell.styles.fontStyle = "bold";
            }
          },
        });

        let finalY = doc.lastAutoTable.finalY;

        doc.autoTable(
          exportColumns,
          conceptosPresupuesto.filter((fila) => {
            // Condición para mantener la fila (ej: no incluir si es una fila de totales o un ID específico)
            return Number(fila.importe) !== 0 || Number(fila.gastado) !== 0;
          }),
          {
            startY: doc.lastAutoTable.finalY + 10,
            columnStyles: {
              2: {
                halign: "right",
              },
              3: {
                halign: "right",
              },
              4: {
                halign: "right",
              },
              5: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Presupuestado":
                  case "Gastado":
                  case "Diferencia":
                  case "%":
                    data.cell.styles.halign = "right";
                    break;
                  default:
                    data.cell.styles.halign = "left";
                    break;
                }
              }
              if (
                data.section === "body" &&
                data.row.index === conceptosPresupuesto.length - 3
              ) {
                data.cell.styles.fontStyle = "bold";
              }
              if (
                data.section === "body" &&
                data.column.index === 1 &&
                (data.cell.text[0] === "LABORAL" ||
                  data.cell.text[0] === "IMPOSITIVO" ||
                  data.cell.text[0] === "OPERACIONES")
              ) {
                data.cell.styles.fontStyle = "bold";
              }
              if (data.column.index === 2) {
                // Si es la primera columna
                if (data.cell.text[0] === "A") {
                  data.cell.text[0] = "";
                }
              }
            },
          },
        );

        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(listadoExcel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "ordenesPagos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag
          value={
            periodoPresupuesto
              ? "Presupuesto Unificado Período " + periodoPresupuesto.periodo
              : "Presupuesto"
          }
        ></Tag>

        {/*  
        <FormControlLabel
          value="yes"
          control={
            <Checkbox
              color="primary"
              checked={periodoActivo}
              style={{ marginLeft: "1vw" }}
              onChange={(e) => {
                setPeriodoActivo(e.target.checked);
                setTimeout(() => {
                  obtenerConceptosPresupuesto({
                    periodo: periodoPresupuesto.periodo,
                    periodo1,
                    periodo2,
                    periodo3,
                  });
                }, 1000);
              }}
            />
          }
          label="Sólo período activo"
          labelPlacement="start"
          style={{ paddingLeft: "1vw" }}
        />
        */}
      </div>
    </Fragment>
  );

  const importeTemplate = (rowData) => {
    return <span>{rowData.importe === "A" ? "" : rowData.importe}</span>;
  };

  const porcentajeTemplate = (rowData) => {
    let cellColor = "";
    let color = "";
    if (
      Number(rowData.porcentaje) >= Number(periodoPresupuesto.porcentaje) &&
      Number(rowData.porcentaje) < 100
    ) {
      cellColor = "yellow";
      color = "black";
    } else {
      if (Number(rowData.porcentaje) >= 100) {
        cellColor = "red";
        color = "white";
      }
    }

    return (
      <span style={{ backgroundColor: cellColor, color: color }}>
        {rowData.porcentaje}
      </span>
    );
  };

  const porcentaje1Template = (rowData) => {
    let cellColor = "";
    let color = "";
    if (
      Number(rowData.porcentaje1) >= Number(periodoPresupuesto.porcentaje) &&
      Number(rowData.porcentaje1) < 100
    ) {
      cellColor = "yellow";
      color = "black";
    } else {
      if (Number(rowData.porcentaje1) >= 100) {
        cellColor = "red";
        color = "white";
      }
    }

    return (
      <span style={{ backgroundColor: cellColor, color: color }}>
        {rowData.porcentaje1}
      </span>
    );
  };

  const porcentaje2Template = (rowData) => {
    let cellColor = "";
    let color = "";
    if (
      Number(rowData.porcentaje2) >= Number(periodoPresupuesto.porcentaje) &&
      Number(rowData.porcentaje2) < 100
    ) {
      cellColor = "yellow";
      color = "black";
    } else {
      if (Number(rowData.porcentaje2) >= 100) {
        cellColor = "red";
        color = "white";
      }
    }

    return (
      <span style={{ backgroundColor: cellColor, color: color }}>
        {rowData.porcentaje2}
      </span>
    );
  };

  const porcentaje3Template = (rowData) => {
    let cellColor = "";
    let color = "";
    if (
      Number(rowData.porcentaje3) >= Number(periodoPresupuesto.porcentaje) &&
      Number(rowData.porcentaje3) < 100
    ) {
      cellColor = "yellow";
      color = "black";
    } else {
      if (Number(rowData.porcentaje3) >= 100) {
        cellColor = "red";
        color = "white";
      }
    }

    return (
      <span style={{ backgroundColor: cellColor, color: color }}>
        {rowData.porcentaje3}
      </span>
    );
  };

  const rowClass = (rowData) => {
    if (
      Number(rowData.importe) === 0 &&
      Number(rowData.gastado) === 0 &&
      periodoActivo
    ) {
      return "displayNone";
    }
    return null;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Período Presupuesto"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <ButtonMui
          onClick={(e) => {
            aceptarFechas();
          }}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  return (
    <Fragment>
      <Menu />
      <ConfirmDialog />
      <Toast ref={toast} />
      <Fragment>
        {statusAcceso === 0 ? <Spinner /> : null}
        {statusAcceso === 400 ? accesoDenegado() : null}
        {statusAcceso === 200 ? (
          <Fragment>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              style={{ align: "center", margin: "1em" }}
            >
              <Button
                icon="pi pi-calendar"
                tooltip="Fechas"
                className="p-button-rounded p-button-success"
                style={{ marginLeft: "1em" }}
                onClick={(e) => calendar()}
              />
              <Button
                id="pdf"
                icon="pi pi-file-pdf"
                tooltip="Pdf"
                className="p-button-rounded p-button-help"
                style={{ marginLeft: "1em" }}
                onClick={exportPdf}
              />

              <Button
                icon="pi pi-download"
                tooltip="Descargar"
                className="p-button-rounded p-button-secondary"
                style={{ marginLeft: "1em" }}
                onClick={downloadClick}
              />

              <Button
                icon="pi pi-times"
                tooltip="Cerrar"
                className="p-button-rounded p-button-primary"
                style={{ marginLeft: "1em" }}
                onClick={exitClick}
              />

              <Button
                id="refrescarPeriodo"
                tooltip="No Visible"
                className="p-button-rounded p-button-primary"
                style={{ display: "none" }}
                onClick={refrescarPeriodoActivo}
              />

              <Button
                id="expButtonExcel"
                tooltip="No Visible"
                className="p-button-rounded p-button-primary"
                style={{ display: "none" }}
                onClick={exportExcel}
              />

              <div className="datatable-responsive-demo">
                <div className="card">
                  <Tooltip target=".export-buttons>button" position="bottom" />
                  <DataTable
                    value={conceptosPresupuesto}
                    selection={selectedRow}
                    onSelectionChange={(e) => setSelectedRow(e.value)}
                    selectionMode="single"
                    rowClassName={rowClass}
                    dataKey="id"
                    header={header}
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                    style={{ fontSize: "small", marginTop: "1vw" }}
                    globalFilter={globalFilter}
                    emptyMessage="No hay datos."
                    paginator
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    rows={500}
                    rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                    //paginatorLeft={paginatorLeft}
                    //paginatorRight={paginatorRight}
                  >
                    <Column
                      field="id"
                      header="ID"
                      //body={idTemplate}
                      //sortable
                      style={{ display: "none" }}
                    ></Column>
                    <Column
                      field="id_presupuesto"
                      header="ID Presupuesto"
                      //body={idTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="concepto"
                      header="Concepto"
                      //body={descripcionTemplate}
                      sortable
                    ></Column>
                    <Column
                      field="importe"
                      header={
                        periodoPresupuesto
                          ? `Pres. ${periodoPresupuesto.periodo}`
                          : null
                      }
                      headerStyle={{ backgroundColor: "olive", color: "white" }}
                      body={importeTemplate}
                      //sortable
                    ></Column>
                    <Column
                      field="gastado"
                      header={`Gastado ${periodoPresupuesto ? periodoPresupuesto.periodo : null}`}
                      headerStyle={{ backgroundColor: "olive", color: "white" }}
                      //body={descripcionTemplate}
                      //sortable
                    ></Column>
                    <Column
                      field="diferencia"
                      header={`Diferencia ${periodoPresupuesto ? periodoPresupuesto.periodo : null}`}
                      headerStyle={{ backgroundColor: "olive", color: "white" }}
                      //sortable
                    ></Column>
                    <Column
                      field="porcentaje"
                      header={`% ${periodoPresupuesto ? periodoPresupuesto.periodo : null}`}
                      headerStyle={{ backgroundColor: "olive", color: "white" }}
                      body={porcentajeTemplate}
                      //sortable
                    ></Column>
                  </DataTable>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}></Grid>
          </Fragment>
        ) : null}
        <Dialog
          header={renderHeaderFechas()}
          visible={visibleFechas}
          closable={false}
          footer={renderFooterFechas()}
          breakpoints={{ "960px": "75vw" }}
          style={{ width: "95vw", paddingBottom: "0" }}
          position="top"
        >
          <Grid container spacing={3} style={{ marginTop: "1vw" }}>
            <Grid item xs={12} md={4}>
              <label htmlFor="vigenciaDesde">Período</label>
              <InputMask
                id="periodo"
                mask="99/99"
                value={periodoSeleccionado ? periodoSeleccionado : null}
                placeholder="99/99"
                //onBlur={handleEnter}
                size={4}
                onChange={(e) => guardarPeriodoSeleccionado(e.value)}
                style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
              ></InputMask>
            </Grid>
          </Grid>
        </Dialog>
      </Fragment>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
